import React from 'react';
import EventMg from '../utilities/EventManager';
import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';
import { enableTouch } from '../utilities/tabletUtil';
import {
  isLoginUserPrimaryCompany,
  isPrimeRoleId,
  isBranchRoleId,
  isManagerRoleId,
} from '../utilities/roleUtility';
import SessionStorageService from '../services/utilities/SessionStorageService';
import Information from './modals/common/Information';
import { messageUtility } from '../utilities/messageUtility';
import { CCUS_SYNCED_STATUS } from '../utilities/constants';

/**
 * 元請けのBOX
 *
 * @export
 * @class FieldTreeConstructor
 * @extends {React.Component}
 */
export default class FieldTreeConstructor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clickable: false,
      name: '',
      company_branch_id: 0,
      field_id: SessionStorageService.getItem('field_id'),
      accordionOpen: false,
      activeA284Flag: SessionStorageService.getActiveA284Flag(), //BLDE_V2-27719
      permissionErrorFlag: false,
      errorMessage: '',
    };

    //体系図ロード
    // eslint-disable-next-line no-unused-vars
    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_LOADED, data => {
      this.setState({
        name: this.props.data.name,
      });
    });

    EventMg.addEventListener(
      FIELD_TREE_EVENTS.TREE_ACCORDION_MENU_OPEN,
      path => {
        if (path === '') {
          // pathがから文字の場合には元請けと判定する
          this.switchAccordionMenu();
        } else {
          this.closeAccordionMenu();
        }
      }
    );
  }

  componentDidMount() {
    // クリック条件チェック(BLDE_V2-13193, BLDE_V2-12043)
    this.checkClickability();
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.permissions !== prevProps.data.permissions) {
      this.checkClickability();
    }
  }

  // クリック条件チェック
  checkClickability() {
    let permissions = this.props.data.permissions;
    const { user, company } = permissions;
    let clickable =
      isLoginUserPrimaryCompany() &&
      (user.edit || user.show || company.append_subtree || company.new);
    this.setState({ clickable });
  }

  // ロールごとの権限エラーメッセージを取得
  getPermissionErrorMessage() {
    if (isPrimeRoleId()) {
      return messageUtility.getMessage('E-000-064');
    } else if (isBranchRoleId()) {
      return messageUtility.getMessage('E-000-065');
    } else if (isManagerRoleId()) {
      return messageUtility.getMessage('E-000-066');
    }
  }

  // 元請BOXの権限チェック
  isEditablePrimeBox() {
    if (!this.props.data.permissions.company.edit) {
      this.setState({
        permissionErrorFlag: true,
        errorMessage: this.getPermissionErrorMessage(),
      });
      return false;
    }
    return true;
  }

  /**
   * アコーディオンメニューの開閉状態を切り替える
   * */
  switchAccordionMenu = () => {
    const accordionOpen = !this.state.accordionOpen;
    this.setState({ accordionOpen });
  };

  /**
   * アコーディオンメニューを強制的に閉じる
   * */
  closeAccordionMenu = () => {
    this.setState({ accordionOpen: false });
  };

  /**
   * アコーディオンメニューレイアウト
   * @returns JSX
   */
  accordionMenu() {
    if (this.state.clickable) {
      return (
        <div className='accordion_menu'>
          {(this.props.data.permissions.partner_box.proxy_register ||
            this.props.data.permissions.partner_box.search_and_add) && (
            <div className='accordion_section'>
              <div className='accordion_label'>下位に協力会社を追加</div>
              <div
                className='accordion_item'
                onClick={() => {
                  if (!enableTouch()) {
                    const options = {
                      path: this.props.path,
                      nodes: this.props.data,
                    };
                    EventMg.trigger(FIELD_TREE_EVENTS.NEW_SEARCH, options);
                  }
                }}
                onTouchStart={() => {
                  const options = {
                    path: this.props.path,
                    nodes: this.props.data,
                  };
                  EventMg.trigger(FIELD_TREE_EVENTS.NEW_SEARCH, options);
                }}
              >
                <i className='icon i-add--field--tree' />
                協力会社を追加
              </div>
            </div>
          )}
          {this.props.data.permissions.partner_box_detail.show && (
            <div className='accordion_section'>
              <div className='accordion_label'>
                元請会社<span>の編集</span>
              </div>
              <div
                className='accordion_item'
                onClick={() => {
                  if (!enableTouch()) {
                    if (!this.isEditablePrimeBox()) {
                      return;
                    }
                    EventMg.trigger(
                      FIELD_TREE_EVENTS.CONSTRUCTOR_EDIT,
                      this.props.path,
                      this.props.data.id
                    );
                  }
                }}
                onTouchStart={() => {
                  if (!this.isEditablePrimeBox()) {
                    return;
                  }
                  EventMg.trigger(
                    FIELD_TREE_EVENTS.CONSTRUCTOR_EDIT,
                    this.props.path,
                    this.props.data.id
                  );
                }}
              >
                <i className='icon icon-add--field--tree--user' />
                管理者・現場監督を招待
              </div>
            </div>
          )}
        </div>
      );
    }
  }

  render() {
    const isDisplayCcusStatus =
      this.props.isCcusDisplayStateFlg &&
      this.props.data.main_jv_ccus_seceded_flag &&
      this.props.data.main_jv_flag;
    return (
      <React.Fragment>
        <div className='fieldstree-company-constructor-wrapper'>
          {isDisplayCcusStatus && (
            <span className='fieldstree-company-constructor--ccus-seceded-status'>
              {CCUS_SYNCED_STATUS.SECEDED.NAME}
            </span>
          )}
          <div
            className={`fieldstree-company-constructor ${
              this.state.clickable
                ? 'fieldstree-company-constructor--operatable'
                : ''
            } ${this.state.accordionOpen ? 'open' : ''} ${
              isDisplayCcusStatus ? '' : 'margin-top__20'
            }`}
            id={`path-${this.props.path}`}
          >
            <div
              className='fieldstree-company__name'
              onClick={() => {
                if (!enableTouch()) {
                  EventMg.trigger(
                    FIELD_TREE_EVENTS.TREE_ACCORDION_MENU_OPEN,
                    ''
                  );
                }
              }}
              onTouchStart={() => {
                EventMg.trigger(FIELD_TREE_EVENTS.TREE_ACCORDION_MENU_OPEN, '');
              }}
            >
              {this.props.data.company_name} {this.props.data.name}
              {this.state.clickable && (
                <div className='field_tree-edit'>
                  編集メニューを開く
                  <span className='arrow' />
                </div>
              )}
            </div>
            {this.accordionMenu()}
          </div>
        </div>
        <Information
          visible={this.state.permissionErrorFlag}
          onClose={() => {
            this.setState({
              permissionErrorFlag: false,
              errorMessage: '',
            });
          }}
          title={messageUtility.getMessage('E-000-063')}
          message={this.state.errorMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          multilineText={true}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldTreeConstructor.jsx